import { message } from "antd";
import { useAlphaAgentStore } from "@/state/alphaAgentStore";

export const updateButtonStates = (buttonNames: string[], currentScroller: any, selectedButton: string | null) => {
  buttonNames.forEach((name) => {
    const button = currentScroller.getByName(name);
    if (button) {
      button.value = button.name === selectedButton;
      button.error = undefined;
    }
  });
};

export const setupButtonGroup = (buttonNames, model, callback, alphaAgent = false) => {
  buttonNames.forEach((name) => {
    model.getByName(name)!.onClick = () => {
      if (alphaAgent) {
        const [b1, b2] = [model.getByName(buttonNames[0]), model.getByName(buttonNames[1])];
        if (!b1.value && !b2.value) {
          const { currentStep, markAnswered } = useAlphaAgentStore.getState();
          markAnswered(currentStep);
        }
      }

      let updatedName = name;

      if (name === "addsummaryTable") {
        const addSmallLineChart = model.getByName("addSmallLineChart");
        if (addSmallLineChart && addSmallLineChart?.value) {
          updatedName = buttonNames[1];
          message.error(
            "There is not enough space on the chart to include both the Summary Table and the Small " +
              "Line Chart features on your primary chart. Please select only one of these options."
          );
        }
        const addCallOutBoxes = model.getByName("addCallOutBoxes");
        if (addCallOutBoxes && addCallOutBoxes?.value) {
          updatedName = buttonNames[1];
          message.error(
            "You cannot select both the Summary Table and Call Out Boxes features on the same chart. " +
              "Please select only one of these options."
          );
        }
      }

      if (name === "addSmallLineChart") {
        const addsummaryTable = model.getByName("addsummaryTable");
        if (addsummaryTable && addsummaryTable?.value) {
          updatedName = buttonNames[1];
          message.error(
            "There is not enough space on the chart to include both the Summary Table and the Small " +
              "Line Chart features on your primary chart. Please select only one of these options."
          );
        }
      }

      if (name === "addCallOutBoxes") {
        const addsummaryTable = model.getByName("addsummaryTable");
        if (addsummaryTable && addsummaryTable?.value) {
          updatedName = buttonNames[1];
          message.error(
            "You cannot select both the Summary Table and Call Out Boxes features on the same chart. " +
              "Please select only one of these options."
          );
        }
      }
      updateButtonStates(buttonNames, model, updatedName);
      callback();
    };
  });
};

export const buttonsValue = (buttonNames: string[], currentScroller: any): string | null => {
  let selectedButton: string | undefined = undefined;

  buttonNames.forEach((name) => {
    const button = currentScroller.getByName(name);
    if (button) {
      if (button.value) {
        selectedButton = button.name;
      }
    }
  });
  return selectedButton;
};
